<template>
  <div class="user-count">
    <transition name="fade">
      <img
        :key="selectedLayer.fore"
        class="foreground z-1"
        :src="selectedLayer.fore"
        :class="`layer-${selectedLayer.id}`"
        alt="Number of users foreground"
      >
    </transition>
    <img class="z-2" :src="laptop">
    <transition name="fade">
      <img
        :key="selectedLayer.back"
        class="background z-3"
        :src="selectedLayer.back"
        :class="`layer-${selectedLayer.id}`"
        alt="Number of users background"
      >
    </transition>
    <img class="z-4" :src="circle" alt="Number of users circle background">
  </div>
</template>

<script>
export default {
  name: 'UserCountIcon',

  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      laptop: require('@/assets/answer-icons/user-count/laptop.svg'),
      circle: require('@/assets/answer-icons/user-count/circle.svg'),
      layers: [
        {
          val: '1-3',
          id: 'layer_1',
          fore: require('@/assets/answer-icons/user-count/fore_1.svg'),
          back: require('@/assets/answer-icons/user-count/back_1.svg')
        },
        {
          val: '4-8',
          id: 'layer_2',
          fore: require('@/assets/answer-icons/user-count/fore_4.svg'),
          back: require('@/assets/answer-icons/user-count/back_4.svg')
        },
        {
          val: '9-14',
          id: 'layer_3',
          fore: require('@/assets/answer-icons/user-count/fore_9.svg'),
          back: require('@/assets/answer-icons/user-count/back_9.svg')
        },
        {
          val: '15+',
          id: 'layer_4',
          fore: require('@/assets/answer-icons/user-count/fore_15.svg'),
          back: require('@/assets/answer-icons/user-count/back_15.svg')
        }
      ]
    }
  },

  computed: {
    totalScore () {
      return this.answer.result.reduce((total, ans) => total + ans.score, 0)
    },
    selectedLayer () {
      if (!this.answer || !this.answer.result) return false
      return this.layers.find(layer => layer.val === this.answer.result.value)
    }
  }
}
</script>

<style scoped lang="scss">
.icon-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}

img {
  position: absolute;
  left: 0;
  top: 0;
}

.z {
  &-1 {
    z-index: 100;
  }
  &-2 {
    z-index: 75;
  }
  &-3 {
    z-index: 50;
  }
  &-4 {
    z-index: 25;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
